export const DeviceTypeList = {
  X_SENSE_MINI_DAVIS: 'X_SENSE_MINI_DAVIS',
  X_SENSE_PRO_DAVIS: 'X_SENSE_PRO_DAVIS',
  X_SENSE_MINI_DAVIS_WITH_PHYTOS_31: 'X_SENSE_MINI_DAVIS_WITH_PHYTOS_31',
  X_SENSE_PRO_DAVIS_WITH_PHYTOS_31: 'X_SENSE_PRO_DAVIS_WITH_PHYTOS_31',
  X_SENSE_MINI_DAVIS_WITH_SOLAR_RADIATION: 'X_SENSE_MINI_DAVIS_WITH_SOLAR_RADIATION',
  X_SENSE_PRO_DAVIS_WITH_SOLAR_RADIATION: 'X_SENSE_PRO_DAVIS_WITH_SOLAR_RADIATION',
  X_SENSE_PRO_DAVIS_WITH_PHYTOS_31_WITH_SOLAR_RADIATION:
    'X_SENSE_PRO_DAVIS_WITH_PHYTOS_31_WITH_SOLAR_RADIATION',
  X_SENSE_PRO_DAVIS_WITH_PHYTOS_31_WITH_SOIL_MOISTURE:
    'X_SENSE_PRO_DAVIS_WITH_PHYTOS_31_WITH_SOIL_MOISTURE',
  X_SENSE_INDOOR: 'X_SENSE_INDOOR',
  X_SENSE_INDOOR_WITH_SOLAR_RADIATION: 'X_SENSE_INDOOR_WITH_SOLAR_RADIATION',
  X_SENSE_INDOOR_WITH_PHYTOS_31: 'X_SENSE_INDOOR_WITH_PHYTOS_31',
  X_SENSE_GATEWAY: 'X_SENSE_GATEWAY',
  X_NODE_TRAP: 'X_NODE_TRAP',
  X_NODE_CAM: 'X_NODE_CAM',
  X_NODE_AT_AH: 'X_NODE_AT_AH',
  X_NODE_SOILWATCH_10_SINGLE: 'X_NODE_SOILWATCH_10_SINGLE',
  X_NODE_SOILWATCH_10_DOUBLE: 'X_NODE_SOILWATCH_10_DOUBLE',
  X_NODE_TEROS_10_SINGLE: 'X_NODE_TEROS_10_SINGLE',
  X_NODE_TEROS_10_DOUBLE: 'X_NODE_TEROS_10_DOUBLE',
  X_NODE_TEROS_10_SOILLESS_MEDIA_SINGLE: 'X_NODE_TEROS_10_SOILLES_MEDIA_SINGLE',
  X_NODE_TEROS_12_SINGLE: 'X_NODE_TEROS_12_SINGLE',
  X_NODE_TEROS_12_DOUBLE: 'X_NODE_TEROS_12_DOUBLE',
  X_NODE_TEROS_12_SOILLESS_MEDIA_SINGLE: 'X_NODE_TEROS_12_SOILLES_MEDIA_SINGLE',
  X_NODE_TEROS_12_SOILLESS_MEDIA_SINGLE_WITH_AT_AH:
    'X_NODE_TEROS_12_SOILLESS_MEDIA_SINGLE_WITH_AT_AH',
  X_NODE_TEROS_21_SINGLE: 'X_NODE_TEROS_21_SINGLE',
  X_NODE_TEROS_21_DOUBLE: 'X_NODE_TEROS_21_DOUBLE',
  X_NODE_WATER: 'X_NODE_WATER',
  X_NODE_SENTEK_10: 'X_NODE_SENTEK_10',
  X_NODE_PHYTOS_31: 'X_NODE_PHYTOS_31',
  X_NODE_SENTEK_30: 'X_NODE_SENTEK_30',
  X_NODE_SENTEK_60: 'X_NODE_SENTEK_60',
  X_NODE_SENTEK_90: 'X_NODE_SENTEK_90',
  X_NODE_SENTEK_10_TRISCAN: 'X_NODE_SENTEK_10_TRISCAN',
  X_NODE_SENTEK_30_TRISCAN: 'X_NODE_SENTEK_30_TRISCAN',
  X_NODE_SENTEK_60_TRISCAN: 'X_NODE_SENTEK_60_TRISCAN',
  X_NODE_SENTEK_90_TRISCAN: 'X_NODE_SENTEK_90_TRISCAN',
  X_NODE_VISIOGREEN_M2: 'X_NODE_VISIOGREEN_M2',
  X_NODE_MOBILE_WITH_CAMPBELL_CS655_SENSOR: 'X_NODE_MOBILE_WITH_CAMPBELL_CS655_SENSOR',
  X_NODE_PH_PROTOTYPE: 'X_NODE_PH_PROTOTYPE',
  X_NODE_GPS_PROTOTYPE: 'X_NODE_GPS_PROTOTYPE',
};
